var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTwitter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.308 44c13.585 0 21.019-11.16 21.019-20.822 0-.314 0-.628-.015-.942A14.972 14.972 0 0048 18.439c-1.325.586-2.752.97-4.25 1.157a7.376 7.376 0 003.256-4.054 14.778 14.778 0 01-4.696 1.77A7.405 7.405 0 0036.922 15c-4.077 0-7.39 3.282-7.39 7.321 0 .571.072 1.128.187 1.67a21.043 21.043 0 01-15.227-7.65 7.267 7.267 0 00-.994 3.683c0 2.54 1.311 4.78 3.285 6.094a7.524 7.524 0 01-3.342-.914v.1c0 3.54 2.55 6.508 5.92 7.179a7.267 7.267 0 01-1.944.257 7.29 7.29 0 01-1.383-.129c.936 2.912 3.673 5.024 6.9 5.08a14.904 14.904 0 01-9.177 3.14c-.59 0-1.18-.028-1.757-.1A21.157 21.157 0 0023.308 44z",
    fill: "#1DA1F2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Twitter.47cff8ab.svg";
export { ForwardRef as ReactComponent };